<template>
  <div>
    <v-menu offset-y transition="slide-y-transition">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" color="#606770" icon text>
          <v-icon>$vuetify.icons.mdiDotsHorizontal</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item ripple  v-if="!checkUnpublishAuth()" @click="reportDialog = true">
          <v-list-item-action>
            <v-icon>$vuetify.icons.mdiAlert</v-icon>
          </v-list-item-action>
          <v-list-item-title>
            {{ $t('feed.report.header') }}
          </v-list-item-title>
        </v-list-item>

        <v-list-item
          ripple
          v-if="checkUnpublishAuth()"
          @click="unpublishDialog = true"
        >
          <v-list-item-action>
            <v-icon>$vuetify.icons.mdiUndo</v-icon>
          </v-list-item-action>
          <v-list-item-title>
            {{ $t('actions.unpublish') }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-dialog
      v-model="reportDialog"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      width="500"
    >
      <v-card>
        <v-card-title class="blue-purple-gradient">
          <span>{{ $t('feed.report.header') }}</span>
          <v-spacer />
          <v-btn class="ma-0" icon @click="reportDialog = false">
            <v-icon color="white">$vuetify.icons.mdiClose</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-radio-group v-model="radios" :mandatory="false" class="mt-0">
            <v-radio
              :label="$t('feed.report.sexualContent')"
              value="sexu"
              class="mb-3"
            />
            <v-radio
              :label="$t('feed.report.violentOrRepulsiveContent')"
              value="viol"
              class="mb-3"
            />
            <v-radio
              :label="$t('feed.report.hatefulOrAbusiveContent')"
              value="hate"
              class="mb-3"
            />
            <v-radio
              :label="$t('feed.report.promotesTerrorism')"
              value="terr"
              class="mb-3"
            />
            <v-radio
              :label="$t('feed.report.spamOrMisleading')"
              value="spam"
              class="mb-3"
            />
            <v-radio
              :label="$t('feed.report.infringesMyRights')"
              value="copy"
              class="mb-3"
            />
            <v-radio :label="$t('feed.report.grammarIssue')" value="gram" />
          </v-radio-group>
        </v-card-text>
        <v-card-actions style="justify-content: flex-end">
          <v-btn text @click="reportDialog = false">
            {{ $t('actions.close') }}
          </v-btn>
          <v-btn
            :disabled="radios == null"
            depressed
            color="accent"
            @click="report()"
          >
            {{ $t('actions.submit') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <verify-dialog
      :verify-dialog="unpublishDialog"
      :action-function="unpublish"
      header="Unpublish this story"
      body="Are you sure you want to unpublish this story?"
      :extra-body="$t('studio.messages.unpublish_story')"
      btn-color="warning"
      :action="$t('actions.unpublish')"
      @close-dialog="unpublishDialog = false"
    />
  </div>
</template>
<script>
import VerifyDialog from '@/components/forms/VerifyDialog.vue'
export default {
  components: {
    VerifyDialog,
  },
  props: {
    object: {
      type: [Object],
      required: true,
      default: function () {},
    },
  },
  data: () => ({
    reportDialog: false,
    unpublishDialog: false,
    radios: null,
  }),
  methods: {
    async unpublish() {
      const formdata = {
        status: 'd',
      }
      try {
        const res = await this.$api.editStory(this.object.slug, formdata)
          this.$router.push(this.localePath('/studio/edit/' + this.object.slug + '/'))
      } catch (e) {
        this.$toast.error(this.$i18n.t('toast.error'), {
          theme: 'bubble',
          duration: 5000,
        })
      }
    },
    async report() {
      const data = {
        category: this.radios,
        object_id: this.object.id,
        type: this.object.get_class,
      }
      try {
        const res = await this.$api.report(data)
        this.$toast.success(this.$i18n.t('toast.form_success'), {
          theme: 'bubble',
          duration: 5000,
        })
        this.reportDialog = false
      } catch (e) {
        this.$toast.error(this.$i18n.t('toast.error'), {
          theme: 'bubble',
          duration: 5000,
        })
      }
    },
    checkUnpublishAuth() {
      if (!this.$auth.loggedIn) return false
      if (this.object.get_teacher == this.$auth.user.username) return true
      if (
        this.object.user &&
        this.object.user.username == this.$auth.user.username
      )
        return true
      return false
    },
  },
}
</script>
